import { useQuery } from '@apollo/client';
import {
  WttpQuestion,
  WttpQuestionByIdDocument,
} from 'src/graphql/generated/graphql';

export const useQuestion = ({ id }: { id: string }) => {
  const { data, loading } = useQuery(WttpQuestionByIdDocument, {
    variables: { wttpQuestionId: id },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return {
    entity: data?.wttpQuestionById as WttpQuestion,
    loading,
  };
};
